import { usePostHog } from "posthog-js/react"
import { useCallback, useState, useMemo, type ChangeEvent } from "react"

export function useFrontsiteAnalytics() {
  const posthog = usePostHog()
  const [hasRecordedFormIntent, setHasRecordedFormIntent] = useState(false)

  const onInputChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.value.length > 3 && !hasRecordedFormIntent) {
        setHasRecordedFormIntent(true)
        posthog.capture("waitlist_form_intent")
      }
    },
    [posthog, hasRecordedFormIntent],
  )

  const recordWaitlistSubmission = useCallback(
    (email: string) => {
      posthog.identify(email, { email })
      posthog.capture("waitlist_submitted", { email })
    },
    [posthog],
  )

  const recordWaitlistFailure = useCallback(
    (reason: string) => {
      posthog.capture("waitlist_submitted_failed", { reason })
    },
    [posthog],
  )

  return useMemo(
    () => ({
      onInputChange,
      recordWaitlistSubmission,
      recordWaitlistFailure,
    }),
    [onInputChange, recordWaitlistSubmission, recordWaitlistFailure],
  )
}
